import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../../environments/environment";


@Injectable()
export class GenericService {
    urlServer: string = environment.URL_SERVER;
    http: HttpClient;
    constructor(private h: HttpClient, private classs: String) {
        this.http = h;
    }

    getAll() {
        return this.http.get<any>(environment.URL_SERVER + this.classs, this.jwt())
            .toPromise()
            .then(res => <any>res)
    }

    getById(id: any) {
        return this.http.get<any>(environment.URL_SERVER + this.classs + "/" + id, this.jwt())
            .toPromise()
            .then(res => <any>res)
    }

    create(obj: any) {
        return this.http.post<any>(environment.URL_SERVER + this.classs + "/", obj, this.jwt())
            .toPromise()
            .then(res => <any>res)
    }

    update(obj: any) {
        return this.http.put<any>(environment.URL_SERVER + this.classs + "/" + obj.id, obj, this.jwt())
            .toPromise()
            .then(res => <any>res)
    }

    delete(id: number) {
        return this.http.delete<any>(environment.URL_SERVER + this.classs + "/" + id, this.jwt())
            .toPromise()
            .then(res => <any>res)
    }


    public jwt() {
        // create authorization header with jwt token
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.getToken() });
        headers.append("Content-Type", "application/json");
        return { headers: headers };
    }

    public getToken() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            return currentUser.token;
        } else
            return "";
    }

    downloadFile(obj: any) {

        return this.http.post(environment.URL_SERVER + "downloadFile/", obj, {
            headers: {
                'Authorization': 'Bearer ' + this.getToken()
            },
            responseType: 'arraybuffer'
        }).toPromise()
            .then(res => <any>res)

    }

}


// WEBPACK FOOTER //
// ./src/app/_services/generic-service.ts